// =============================================
// Admin Store - Zustand
// KipiKid - ממשק ניהול
// =============================================

import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface AdminState {
  selectedOrganizationId: string | null;
  selectedOrganizationName: string | null;
  setSelectedOrganization: (id: string | null, name: string | null) => void;
  clearOrganizationFilter: () => void;
}

export const useAdminStore = create<AdminState>()(
  persist(
    (set) => ({
      selectedOrganizationId: null,
      selectedOrganizationName: null,

      setSelectedOrganization: (id, name) =>
        set({ selectedOrganizationId: id, selectedOrganizationName: name }),

      clearOrganizationFilter: () =>
        set({ selectedOrganizationId: null, selectedOrganizationName: null }),
    }),
    {
      name: 'kipikid-admin',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({
        selectedOrganizationId: state.selectedOrganizationId,
        selectedOrganizationName: state.selectedOrganizationName,
      }),
    }
  )
);
